export default __webpack_public_path__ + "static/media/BathroomShelf.58acec60.mp4";